import { createLightTheme, type BrandVariants, type Theme } from "@fluentui/react-components";

// Cuntas MíTool brand (Irish green). Single-sourced here so every host
// (Word task pane, web app, Google Docs sidebar) wraps its tree in
// <FluentProvider theme={greenTheme}> with identical styling.
const greenBrand: BrandVariants = {
	10: "#021a0c",
	20: "#043318",
	30: "#064d24",
	40: "#086630",
	50: "#0a803c",
	60: "#0d9948",
	70: "#169b62",
	80: "#2eab73",
	90: "#4dba86",
	100: "#6dc99a",
	110: "#8dd8ae",
	120: "#ade7c2",
	130: "#cef5d7",
	140: "#e6faeb",
	150: "#f2fdf5",
	160: "#f9fefb",
};

export const greenTheme: Theme = createLightTheme(greenBrand);
